import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatTooltipModule } from '@angular/material';
import { AvelonIncidencesReceptionShowJsonComponent } from "./avelon-incidences-reception-show-json.component";



@NgModule({
  declarations: [AvelonIncidencesReceptionShowJsonComponent],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    MatTooltipModule
  ],
  entryComponents: [
    AvelonIncidencesReceptionShowJsonComponent
  ]
})
export class AvelonIncidencesReceptionShowJsonModule {}
